<template>
  <v-dialog v-model="attachmentDialog" max-width="1200">
    <v-btn icon slot="activator">
      <v-icon color="secondary">attach_file</v-icon>
    </v-btn>

    <v-card class="pa-4">
      <v-card-title class="pa-0 pb-2">
        <h2 v-if="allowSelectMultiple">Select documents to attach</h2>
        <h2 v-else>Select document to attach</h2>
        <v-flex shrink class="pl-4">
          <v-btn @click="$refs.documentsTable.openBrowser()" color="secondary" class="mt-0 ml-0 mr-2 white--text">
            <v-icon class="mr-2" left dark>file_upload</v-icon>Upload
          </v-btn>
        </v-flex>
      </v-card-title>

      <DocumentsTable
        v-if="attachmentDialog"
        :documentHeaders="docsHeader"
        :files="currentCase.fileAttachments"
        :caseId="parseInt(currentCase.id, 10)"
        :isAttachmentMode="true"
        :allowSelectMultiple="allowSelectMultiple"
        ref="documentsTable"
      ></DocumentsTable>

      <v-flex class="pb-0">
        <span v-if="selectedAttachments.length">
          <h2 v-if="allowSelectMultiple">Selected documents</h2>
          <h2 v-else>Selected document</h2>
        </span>
        <v-flex xs class="mt-2 selected-docs">
          <v-flex class="p-relative mr-4  pr-2 mb-1" d-inline-block v-for="item in selectedAttachments" :key="item.name">
            <font-awesome-icon size="2x" :icon="['far', item.icon]" class="secondary--text mr-3"></font-awesome-icon><h3 class="d-inline-block" >{{ item.name }}</h3>
            <v-btn icon @click="unselectAttachment(item)" class="remove-btn">
              <v-icon color="error">cancel</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
        <v-flex xs class="mt-2">
          <v-card-actions class="ma-0 pa-0 pt-2">
            <v-btn @click="attachToCase()" color="success">Select</v-btn>
            <v-btn @click="unselectAttachments()" color="secondary">Cancel</v-btn>
          </v-card-actions>
        </v-flex>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>
import DocumentsTable from "@/components/documents/DocumentsTable.vue"

export default {
  name: "AttachmentsDialog",
  components: { DocumentsTable },
  props: {
    attachments: {
      type: Array,
      required: true
    },
    allowSelectMultiple: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    },
    currentCase: {
      type: Object,
      required: true
    },
    selectedAttachments: {
      type: Array
    }
  },
  created() {
    this.$store.dispatch('clearFileSelection')
  },
  methods: {
    attachToCase() {
      if (!this.allowSelectMultiple && this.selectedAttachments.length) {
        const file = this.selectedAttachments[0]
        const attachment = this.attachments.find(a => file.id === a.id)
        this.$emit('selected-file-attachment', attachment)
      }
      this.attachmentDialog = false
    },
    unselectAttachment(file) {
      file.selected = false
      this.$store.dispatch("toggleFileSelection", { file, allowSelectMultiple: this.allowSelectMultiple })
    },
    unselectAttachments() {
      this.$store.dispatch("toggleFilesSelection", { files: this.selectedAttachments, selected: false })
      this.attachmentDialog = false
    },
    isCurrentlySelected(file) {
      if (this.selectedAttachments) {
        const selected = this.selectedAttachments.find(f => f.url === file.url)
        return !!selected
      }
    }
  },
  data: () => ({
    name: "AttachmentsDialog",
    attachmentDialog: false,
    docsHeader: [
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      { text: 'Date added', value: 'date' },
      { text: 'Size', value: 'size' },
      { text: 'Uploaded by', value: 'modified' }
    ],
    selected: []
  })
}
</script>
